import styled from 'styled-components';

import { Title } from '@components/shippingCountries/shippingCountries.styles';

export const Container = styled.div`
  padding: 0 13px;
  height: 100%;
`;

export const ButtonsContainer = styled.div`
  padding: 17px 0 34px;

  > * {
    margin-top: 17px;
  }
`;

export const FormTitle = styled(Title)``;
